export default "__VITE_ASSET__c848058a__"